﻿export const SHOW_ALERT = 'SHOW_ALERT';
export const UPDATE_BASKET = 'UPDATE_BASKET';
export const REGISTER_BASKET = 'REGISTER_BASKET';
export const HIDE_ALERT = 'HIDE_ALERT';
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const IS_BAD_PAYER = 'IS_BAD_PAYER';
export const VALIDATE_FORM_BLOCK = 'VALIDATE_FORM_BLOCK';
export const REGISTER_FORM_BLOCK = 'REGISTER_FORM_BLOCK';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const EXISTING_CUSTOMER_BLOCK_ACTIVE = 'EXISTING_CUSTOMER_BLOCK_ACTIVE';
export const VALIDATE_CUSTOMER_DATA = 'VALIDATE_CUSTOMER_DATA';
export const IS_EXISTING_CUSTOMER = 'IS_EXISTING_CUSTOMER';
